import '{src}/javascripts/sharedWithConsole/docsearch/console.scss'

import { DocSearch } from '@docsearch/react'
import { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { docsearchConfig } from ':/_src/javascripts/sharedWithConsole/docsearch/config.ts'
import userIcon from '{cImg}/user.svg'
import Tooltip from '~/components/Tooltip/index.tsx'
import HeaderAnnouncementsTooltip from '~/features/announcements/components/HeaderAnnouncementsTooltip.tsx'

import DesktopUserDropdown from './DesktopUserDropdown.tsx'
import transloaditIcon from '../images/transloadit.svg'

function DesktopHeader() {
  const [isUserTooltipOpen, setIsUserTooltipOpen] = useState(false)

  const location = useLocation()

  useEffect(() => {
    setIsUserTooltipOpen(false)
  }, [location.pathname])

  const handleToggleUserTooltip = useCallback(() => {
    setIsUserTooltipOpen((isOpen) => !isOpen)
  }, [])
  const handleCloseUserTooltip = useCallback(() => {
    setIsUserTooltipOpen(false)
  }, [])

  return (
    <header className="header header--desktop">
      <div className="tl-container tl-container--header">
        <div className="logo">
          <a href="/">
            <img className="logo__img" src={transloaditIcon} alt="Transloadit" />
          </a>
        </div>

        <div className="header__nav">
          <div className="header__nav-link">
            <DocSearch {...docsearchConfig} />
          </div>

          <a className="header__nav-link header__nav-link--docs" href="/docs">
            Docs
          </a>

          <HeaderAnnouncementsTooltip />

          <Tooltip
            type="dropdown"
            placement="bottom-end"
            visible={isUserTooltipOpen}
            onClickOutside={handleCloseUserTooltip}
            content={<DesktopUserDropdown />}
          >
            <button
              type="button"
              className="btn btn--clear header__nav-link account-menu"
              onClick={handleToggleUserTooltip}
              aria-label="Account menu"
            >
              <img className="account-menu__img" src={userIcon} alt="" aria-hidden />
            </button>
          </Tooltip>
        </div>
      </div>
    </header>
  )
}

export default DesktopHeader
